import image1 from 'images/product-cards/product-card-0.jpg';
import image2 from 'images/product-cards/product-card-3.jpg';
import image3 from 'images/product-cards/product-card-2.jpg';
import image4 from 'images/product-cards/product-card-1.jpg';

import logo1 from 'images/products-logo/product-logo-3.svg';
import logo2 from 'images/products-logo/product-logo-2.svg';
import logo3 from 'images/products-logo/product-logo-1.svg';
import logo4 from 'images/products-logo/product-logo-0.svg';

export const data = [
    {
        title: 'Organic line',
        text: 'Betino® and VeganoХ® is approved by FiBL and Organic Standard for use in organic farming without restrictions. It is a reliable solution for increasing plant resistance to osmotic and oxidative stress.',
        img: image1,
        logo: logo1,
    },
    {
        title: 'Wuxal',
        text: 'Wuxal® — is an effective suspension for foliar treatment of plants and seed treatment, as well as a set of innovative solutions that allow you to achieve high efficiency.',
        img: image2,
        logo: logo2,
    },
    {
        title: 'Fertiplant',
        text: 'With Fertiplant® fertilizers, you can fully rely on the impeccable quality of the product and its optimal properties.',
        img: image3,
        logo: logo3,
    },
    {
        title: 'UniferX',
        text: 'UniferX is a high quality fine crystalline fertilizer for foliar feeding. It is designed to quickly eliminate or prevent manganese deficiency in plants.',
        img: image4,
        logo: logo4,
    },
];
